import { styled } from "styled-components";
import { Button, Divider, Input } from "antd";
import {
  IDashboard,
  IDashboardFilter,
  IPageableResponse,
  IPaginationFilters,
  Loading,
  openNotification,
} from "@dataone/lib";
import DashboardPages from "../dashboard-pages/DashboardPages";
import { useState } from "react";
import DashboardForm from "../dashboard-form/DashboardForm";
import PageForm from "../page-form/PageForm";
import { PlusOutlined } from "@ant-design/icons";
import { ArrowDownIcon, EmptyIcon, SearchIcon } from "@dataone/icons";

interface DashboardListProps {
  dashboardFilters: IPaginationFilters<IDashboardFilter, IDashboard>;
  setDashboardFilters: React.Dispatch<
    IPaginationFilters<IDashboardFilter, IDashboard>
  >;
  selectedDashboard: {
    index: number;
    id: string;
    name: string;
  };
  setSelectedDashboard: React.Dispatch<
    React.SetStateAction<{
      index: number;
      id: string;
      name: string;
    }>
  >;
  isLoading: boolean;
  dashboards: IPageableResponse<Required<IDashboard>> | undefined;
  setSelectedPage: React.Dispatch<{ index: number; id: string; name: string }>;
  selectedPage: { index: number; id: string; name: string };
  refetchDashboards: (options?: {}) => void;
}

const DashboardList = ({
  dashboardFilters,
  setDashboardFilters,
  selectedDashboard,
  setSelectedDashboard,
  isLoading,
  dashboards,
  setSelectedPage,
  selectedPage,
  refetchDashboards,
}: DashboardListProps) => {
  const [dashCollapsed, setDashCollapsed] = useState<boolean>(false);
  const [newPageButtonClicked, setNewPageButtonClicked] =
    useState<boolean>(false);
  const [newDashButtonClicked, setNewDashButtonClicked] =
    useState<boolean>(false);
  const [tempSelectedDashboard, setTempSelectedDashboard] = useState<{
    index: number;
    id: string;
    name: string;
  }>({ index: -1, id: "", name: "" });
  const handleDashSelected = (
    index: number,
    dashboard: IDashboard,
    name: string
  ) => {
    if (
      // index === selectedDashboard.index ||
      index === tempSelectedDashboard.index
    ) {
      setDashCollapsed(!dashCollapsed);
      setTempSelectedDashboard({ index: -1, id: "", name: "" });
      if (selectedPage.index < 0) {
        setSelectedDashboard({ index: -1, id: "", name: "" });
      }
      return;
    } else if (index !== tempSelectedDashboard.index) {
      const dashId = dashboard.id as String;
      setTempSelectedDashboard({ index, id: dashId.toString(), name });
      // setSelectedDashboard({ index, id: dashId.toString(), name });
      // setSelectedPage({ index: -1, id: "", name: "" });
      setDashCollapsed(false);
    }
  };

  // const handlePageSelected = (index: number, dashboard: IDashboard) => {
  //   if (dashboard?.pages?.[0])
  //     setSelectedPage({
  //       index: 0,
  //       id: dashboard?.pages?.[0].id ?? "",
  //       name: dashboard?.pages?.[0].name ?? "",
  //     });
  // };

  const handleCancel = () => {
    setNewPageButtonClicked(false);
    setNewDashButtonClicked(false);
  };
  const handleNewDashClicked = () => {
    setNewDashButtonClicked(true);
  };
  const handleOnSuccess = (message: string) => {
    openNotification(message);
    //handleCancel();
    const updatedBeforeDate = new Date(
      new Date().setSeconds(new Date().getSeconds() + 1)
    );
    setDashboardFilters({
      ...dashboardFilters,
      beforeDate: updatedBeforeDate,
    });
    handleCancel();
  };
  return (
    <>
      <StyledHeader>
        <HeaderTitle> Dashboards</HeaderTitle>
        {!newDashButtonClicked && !newPageButtonClicked && (
          <StyledAddDashboardBtn onClick={handleNewDashClicked}>
            <span>Add new dashboard</span>
            <PlusOutlined />
          </StyledAddDashboardBtn>
        )}
      </StyledHeader>
      <StyledDashboardListContainer>
        <StyledDashboardList>
          {!newPageButtonClicked && !newDashButtonClicked && (
            <StyledSearch>
              <Input
                className="search-input"
                placeholder="Search Dashboard..."
                maxLength={255}
                bordered={false}
                onChange={(e) =>
                  setDashboardFilters({
                    ...dashboardFilters,
                    body: { name: e.target.value },
                  })
                }
                prefix={
                  <StyledSearchIcon>
                    <SearchIcon />
                  </StyledSearchIcon>
                }
              />
            </StyledSearch>
          )}

          {isLoading ? (
            <Loading />
          ) : newPageButtonClicked ? (
            <PageForm
              handleCancel={handleCancel}
              dashboardId={tempSelectedDashboard.id}
              handleOnSuccess={handleOnSuccess}
            />
          ) : newDashButtonClicked ? (
            <DashboardForm
              handleCancel={handleCancel}
              handleOnSuccess={handleOnSuccess}
            />
          ) : (
            <StyledList>
              {dashboards?.totalElements! > 0 ? (
                dashboards?.content.map((dashboard, index) => {
                  return (
                    <div key={index}>
                      <div
                        className={`dashboard-list-title${
                          index === selectedDashboard.index ? " active" : ""
                        }`}
                        onClick={() => {
                          handleDashSelected(index, dashboard, dashboard.name);
                          // handlePageSelected(index, dashboard);
                        }}
                      >
                        <img
                          className="dashboard-list-icon"
                          alt="background"
                          src={`/images/dashboard/cards/icons/icon-dash-${dashboard.theme}.svg`}
                        />
                        <h3>{dashboard.name}</h3>
                        <StyleddashListIcon
                          down={
                            !dashCollapsed &&
                            index === tempSelectedDashboard.index
                              ? true
                              : false
                          }
                          className="dashboard-list-icon"
                        >
                          <ArrowDownIcon />
                        </StyleddashListIcon>
                      </div>
                      {index === tempSelectedDashboard.index &&
                        !dashCollapsed && (
                          <>
                            <DashboardPages
                              selectedDashboard={tempSelectedDashboard}
                              setSelectedDashboard={setSelectedDashboard}
                              selectedPage={selectedPage}
                              setSelectedPage={setSelectedPage}
                              isLoading={isLoading}
                              dashboards={dashboards}
                              setNewPageButtonClicked={setNewPageButtonClicked}
                            />
                            <Divider />
                          </>
                        )}
                    </div>
                  );
                })
              ) : (
                <EmptyDashList>
                  <span className="empty-icon">
                    <EmptyIcon />
                  </span>
                  <h3>Dashboards</h3>
                  <p>No dashboard added yet</p>
                  <Button onClick={handleNewDashClicked}>
                    Create new dashboard
                  </Button>
                </EmptyDashList>
              )}
            </StyledList>
          )}
        </StyledDashboardList>
      </StyledDashboardListContainer>
    </>
  );
};

export default DashboardList;

const StyledHeader = styled.h1`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0px;
  width: 325px;
`;
const HeaderTitle = styled.span`
  color: #4974f6;
  font-weight: 700;
  font-size: 23px;
  margin: 10px 5px;
`;

const StyledDashboardList = styled.div`
  padding: 17px 20px;
  border-radius: 20px 20px 0px 0px;
  background: #eff1fd;
  position: absolute;
  bottom: 0;
  top: 94px;
  // width: 460px;
  width: 320px;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 0px;
  }
`;

const StyledSearch = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 3%;
  padding-bottom: 10px;
  border-bottom: 3px solid rgba(73, 116, 246, 0.75);
  // width: 400px;
  width: 280px;

  .anticon-loading {
    font-size: 23px;
    margin-right: 10px;
  }
  .search-input::placeholder {
    font-weight: 400 !important;
    font-size: 15px !important;
    line-height: 26px !important;
    letter-spacing: -0.015em !important;
    color: rgba(4, 7, 38, 0.75) !important;
  }

  .search-input {
    font-weight: 400 !important;
    font-size: 15px !important;
  }
`;
const StyledList = styled.div`
  // height: 338px;
  height: 93%;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0px;
  }
  // padding: 9px 20px;
  padding: 9px 12px;
  .dashboard-list-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 11px 0px;
    cursor: pointer;
    background: #fff;
    border-radius: 10px;
    height: 36px;
    margin-bottom: 10px;
    padding-left: 9px;
  }
  .active {
    border-radius: 10px;
    background: #eff1fd;
    box-shadow: none;
  }
  .dashboard-list-title:hover {
    border-radius: 10px;
    background: #4974f6;
    color: #fff;
  }
  .dashboard-list-icon {
    width: 23px;
  }

  h3 {
    font-size: 14px;
    font-weight: 500;
    letter-spacing: -0.27px;
    margin: 0px 0px 0px 17px;
    overflow: hidden;
    word-break: break-word;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 1;
  }
  .ant-divider-horizontal {
    margin: 0px;
  }
`;
const StyledAddDashboardBtn = styled.div`
  display: flex;
  gap: 10px;
  cursor: pointer;
  font-size: 15px;
`;
const EmptyDashList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  h3 {
    color: #040726;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
  }
  .ant-btn-default {
    border-radius: 11.25px;
    background: var(--black-100, #fff);
    color: #4974f6;
    border: none;
    &:hover {
      color: #4974f6 !important;
      border: none !important;
    }
  }
  .empty-icon {
    font-size: 50px;
    color: #4974f6;
  }
`;
const StyledDashboardListContainer = styled.div`
  min-width: 451px;
`;

const StyledSearchIcon = styled.div`
  margin-right: 6px;
  font-size: 16px;
  display: flex;
`;

const StyleddashListIcon = styled.div<{ down: boolean }>`
  margin-left: auto;
  display: flex;
  font-size: 10px;
  color: #000;
  width: 10px;
  transform: ${(props) => (props.down ? "rotate(180deg)" : "rotate(0deg)")};
  margin-right: ${(props) => (props.down ? "12px" : "0px")};
`;
